// Tema baseado na identidade visual Mariana Mello | Sono e Rotina

export const theme = {
  colors: {
    // Paleta Principal - Roxo da Noite
    purple: {
      dark: '#30244F',
      light: '#8F7AC5',
      medium: '#9984CF'
    },
    // Paleta Secundária - Rosa dos Sonhos
    pink: {
      light1: '#B47CBF',
      light2: '#D98DAE',
      salmon: '#F2ACAA',
      peach: '#FAE0D5',
      ice: '#FBF4FF'
    },
    // Utilitários
    white: '#FFFFFF',
    text: {
      primary: '#30244F',
      secondary: '#6B5B8C',
      muted: '#9890A8'
    },
    success: '#7BC47F',
    warning: '#F5C26B',
    error: '#E57373',
    // Gradientes
    gradients: {
      purple: 'linear-gradient(135deg, #8F7AC5 0%, #30244F 100%)',
      pink: 'linear-gradient(135deg, #F2ACAA 0%, #FBF4FF 100%)',
      soft: 'linear-gradient(135deg, #FBF4FF 0%, #FAE0D5 100%)'
    }
  },
  fonts: {
    primary: "'Poppins', sans-serif",
    secondary: "'Quicksand', sans-serif" // Fallback para Bumil
  },
  borderRadius: {
    sm: '8px',
    md: '12px',
    lg: '20px',
    xl: '32px',
    full: '9999px'
  },
  shadows: {
    sm: '0 2px 8px rgba(48, 36, 79, 0.08)',
    md: '0 4px 16px rgba(48, 36, 79, 0.12)',
    lg: '0 8px 32px rgba(48, 36, 79, 0.16)',
    glow: '0 0 20px rgba(143, 122, 197, 0.3)'
  }
};

export const assets = {
  logos: {
    v1: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/f3mtzaal_Logo%20V1.svg',
    v1SonoRotina: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/8cc75h2h_Logo%20V1%20-%20Sono%20e%20Rotina.svg',
    v1SonoRotinaRoxo: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/6wzthxo4_Logo%20V1%20-%20Sono%20e%20Rotina%20-%20Roxo.svg',
    v2: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/eftysd4n_Logo%20V2.svg',
    v2SonoRotina: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/rgfyzdbn_Logo%20V2%20-%20Sono%20e%20Rotina.svg',
    v3: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/jh91hvpf_Logo%20V3.svg',
    v3SonoRotina: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/uca4nv43_Logo%20V3%20-%20Sono%20e%20Rotina.svg'
  },
  icons: {
    default: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/0qfkyewv_%C3%8Dcone.svg',
    purple: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/4vq6wef0_%C3%8Dcone%20-%20Roxo.svg',
    white: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/2w8mbjd1_%C3%8Dcone%20-%20Branco.svg',
    cream: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/tvp6x1iw_%C3%8Dcone%20-%20Creme.svg',
    ice: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/uf5rn14o_%C3%8Dcone%20-%20Gelo.svg'
  },
  frames: {
    purple: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/aqjgvxob_Moldura%203.png',
    pink: 'https://customer-assets.emergentagent.com/job_sleep-routine-app/artifacts/iv0lqy4w_Moldura%204.png'
  }
};
